import { IMAGES } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";
import { scrollToId } from "@/lib/scroll";

export default function BookingCTA() {
  return (
    <section
      data-testid="booking-cta-section"
      className="relative h-[70vh] min-h-[480px] flex items-center justify-center overflow-hidden"
    >
      <img
        src={IMAGES.ctaBanner}
        alt="Detailed motorcycle"
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-ink/80" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(201,162,39,0.12)_0%,transparent_60%)]" />

      <div className="relative z-10 text-center px-4 sm:px-6 max-w-3xl mx-auto">
        <Reveal>
          <h2 className="font-serif text-4xl sm:text-6xl lg:text-7xl text-cream uppercase tracking-tight leading-[0.95]">
            Ready To Make Your Bike
            <br />
            <span className="gold-text italic lowercase">look its best?</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-7 text-cream/70 text-base sm:text-lg font-light">
            Give your motorcycle the MOTO LUXE treatment.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <button
              data-testid="cta-book-detail-button"
              onClick={() => scrollToId("contact")}
              className="inline-flex items-center justify-center bg-gold text-ink px-8 py-4 font-mono text-xs tracking-[0.22em] uppercase hover:bg-champagne transition-colors duration-300"
            >
              Book Your Detail
            </button>
            <button
              data-testid="cta-contact-button"
              onClick={() => scrollToId("contact")}
              className="inline-flex items-center justify-center border border-white/30 text-cream px-8 py-4 font-mono text-xs tracking-[0.22em] uppercase hover:border-gold hover:text-gold transition-colors duration-300"
            >
              Contact MOTO LUXE
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
